// Agent configuration
export const AGENTS = {
  chatproxy_v4: {
    id: "chatproxy_v4",
    label: "T-Global Agent",
    description: "Product information & support",
    url: "https://us-central1-chandini-project.cloudfunctions.net/chatproxy_v5_translator",
    // url: "http://127.0.0.1:5001/chandini-project/us-central1/chatproxy_translator",
  },
  chatproxy_NTUST: {
    id: "chatproxy_NTUST",
    label: "Video Agent",
    description: "Video based source agent for Q&A",
    url: "https://us-central1-chandini-project.cloudfunctions.net/chatproxy_NTUST",
    // localUrl: "http://127.0.0.1:5001/chandini-project/us-central1/chatproxy_NTUST",
  },
  Gemini_Agent: {
    id: "Gemini_Agent",
    label: "LLM Agent for Image and Documents Analysis",
    description: "Upload your own sources files for Q&A",
    url: "https://us-central1-chandini-project.cloudfunctions.net/chatproxy_Gemini",
    // localUrl: "http://127.0.0.1:5001/chandini-project/us-central1/chatproxy_Gemini",
  },
};

export const DEFAULT_AGENT = "chatproxy_v4";

export const FEEDBACK_API_URL =
  "http://localhost:5000/api/feedback/thumbs-down";

// Resolve the API URL for a given agent
export const getAgentUrl = (agentId) => {
  const agent = AGENTS[agentId];
  if (!agent) return null;
  return agent.url;
};

// Sample questions for each page, used by the chatproxy_v4 agent
export const SAMPLE_QUESTIONS_PAGES = [
  // Page 0
  {
    columns: 3, // md:grid-cols-3
    questions: [
      {
        category: "Product Search",
        text: "Which thermal pad has thickness less than 0.3mm",
      },
      {
        category: "Specifications",
        text: "TG-A3500 的 thermal conductivity 是多少",
      },
      {
        category: "Comparison",
        text: "Do comparison for TG4040, TG6060",
      },
    ],
  },
  // Page 1
  {
    columns: 2, // md:grid-cols-2
    questions: [
      {
        category: "單一規格查詢",
        text: "TG-A3500 的 thermal conductivity 是多少？",
      },
      { category: "簡稱查詢", text: "TG-A3500 的 K 是多少？" },
      {
        category: "多產品規格 (中文)",
        text: "請問 TG-A3500、TG-A1250、TG-A6200 的 thermal conductivity、operating temperature，以及 hardness 是多少？",
      },
      {
        category: "Multi-Spec (Abbr)",
        text: "what is K, OT, shore oo of TG-A3500, TG-A1250, TG-A6200",
      },
      {
        category: "Multi-Spec (Full)",
        text: "what is thermal conductivity, Operating Temperature, hardness of TGA3500, TGA1250, TGA6200",
      },
      {
        category: "Filtered Search",
        text: "list all thermal pad with thermal conductivity > 3",
      },
    ],
  },
  // Page 2
  {
    columns: 2, // md:grid-cols-2
    questions: [
      {
        category: "Category Filter",
        text: "list all thermal putty with viscosity > 400",
      },
      {
        category: "Competitor Compare",
        text: "Compare TG-A2200 and Laird:Tflex SF7",
      },
      {
        category: "Concept Query",
        text: "what is thermal conductivity?",
      },
      {
        category: "Technical Detail",
        text: "Explain the meaning of the equation q = −k∇T.",
        // colSpan: 2, // md:col-span-2
      },
    ],
  },
];

export const TOTAL_SAMPLE_PAGES = SAMPLE_QUESTIONS_PAGES.length;
